export class OverrideSensitivityAnnotationsRequest {
    'hasSensitivityAnnotations';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "hasSensitivityAnnotations",
            "baseName": "hasSensitivityAnnotations",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return OverrideSensitivityAnnotationsRequest.attributeTypeMap;
    }
    constructor() {
    }
}
